import React from 'react';
import { Users, Building2 } from 'lucide-react';

const CareersHero = ({ className = "" }) => {
  const scrollToPositions = () => {
    const element = document.getElementById('open-positions');
    if (element) {
      const offset = 100;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToCulture = () => {
    const element = document.getElementById('why-join-us');
    if (element) {
      const offset = 100;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className={`relative min-h-[70vh] bg-[var(--primarycolor)] overflow-hidden ${className}`}>
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 md:px-12 h-full flex items-center justify-center py-20">
        <div className="max-w-4xl text-center">
          {/* Content */}
          <div className="text-white">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full text-sm font-medium mb-8">
              <Users className="w-4 h-4" />
              Join Our Team
            </div>
            
            <h1 className="text-5xl md:text-6xl font-light mb-6 leading-tight">
              Build Careers with
              <span className="block text-white font-normal mt-2">Purpose & Impact</span>
            </h1>
            
            <p className="text-xl text-red-100 leading-relaxed mb-8 mx-auto max-w-3xl">
              Join us in creating exceptional senior living experiences where compassion meets innovation, and every team member contributes to building communities that truly matter.
            </p>
            
            <div className="flex flex-wrap gap-4 justify-center">
              <button 
                onClick={scrollToPositions}
                className="bg-white text-[var(--primarycolor)] hover:bg-red-50 px-8 py-4 rounded-xl font-semibold transition-all duration-300 flex items-center gap-3"
              >
                View Open Positions
                <Building2 className="w-5 h-5" />
              </button>
              <button 
                onClick={scrollToCulture}
                className="border-2 border-white text-white hover:bg-white/10 px-8 py-4 rounded-xl font-semibold transition-all duration-300"
              >
                Our Culture
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersHero;